// extracted by mini-css-extract-plugin
export var comparedProductInfoMob = "style-mod--compared-product-info-mob--9182f";
export var comparedProductMob = "style-mod--compared-product-mob--f65a5";
export var firstColumn = "style-mod--first-column--78300";
export var hideOnDesktop = "style-mod--hide-on-desktop--66f10";
export var olavInfo = "style-mod--olav-info--cad85";
export var olavLogo = "style-mod--olav-logo--6a091";
export var ourFeatures = "style-mod--our-features--5edec";
export var pfContainer = "style-mod--pf-container--b0baf";
export var pfContent = "style-mod--pf-content--6875a";
export var pfData = "style-mod--pf-data--181d0";
export var pfHeader = "style-mod--pf-header--bc58a";
export var pfTitle = "style-mod--pf-title--0211e";
export var productComparions = "style-mod--product-comparions--53774";
export var productFeatures = "style-mod--product-features--727db";
export var productFeaturesBox = "style-mod--product-features-box--2c94f";
export var secondColumn = "style-mod--second-column--b34f0";
export var subTitle = "style-mod--sub-title--9a6d2";
export var title = "style-mod--title--75700";
export var titleAndDescription = "style-mod--title-and-description--47a5e";
export var titleAndSubtitle = "style-mod--title-and-subtitle--aa2c9";